"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MfaModalContent = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var end2end_1 = require("@hudled/end2end");
var material_1 = require("@mui/material");
var auth_1 = require("firebase/auth");
var firestore_1 = require("firebase/firestore");
var qrcode_react_1 = require("qrcode.react");
var react_1 = __importStar(require("react"));
var react_redux_1 = require("react-redux");
var react_redux_firebase_1 = require("react-redux-firebase");
var LoadingSpinner_1 = __importDefault(require("atomicComponents/atoms/Icons/LoadingSpinner"));
var BlendButton_1 = __importDefault(require("atomicComponents/molecules/Buttons/BlendButton"));
var Heading_1 = __importDefault(require("shared/components/Heading"));
var Text_1 = __importDefault(require("shared/components/Text"));
var hooks_1 = require("utils/hooks");
var single_1 = require("utils/selectors/single");
var QRInput_1 = __importDefault(require("./QRInput"));
var Relogin_1 = __importDefault(require("./Relogin"));
var VerifyEmail_1 = __importDefault(require("./VerifyEmail"));
var MFA_DISPLAY_NAME = end2end_1.IS_RECHARGLY ? 'Rechargly' : 'Hudled';
var MfaModalContent = function (_a) {
    var _b;
    var onClose = _a.onClose;
    var authState = (0, react_redux_1.useSelector)(single_1.selectAuth);
    var _c = __read(react_1.default.useState(authState.emailVerified), 2), emailVerified = _c[0], setEmailVerified = _c[1];
    // const` [requestingTotp, setRequestingTotp] = React.useState(false);
    var _d = __read(react_1.default.useState(null), 2), totpSecret = _d[0], setTotpSecret = _d[1];
    var _e = __read(react_1.default.useState(''), 2), totp = _e[0], setTotp = _e[1];
    var _f = __read(react_1.default.useState(false), 2), needsSubmitReauth = _f[0], setNeedsSubmitReauth = _f[1];
    var _g = __read(react_1.default.useState(''), 2), totpValidationError = _g[0], setTotpValidationError = _g[1];
    var _h = __read(react_1.default.useState(''), 2), error = _h[0], setError = _h[1];
    var firebase = (0, react_redux_firebase_1.useFirebase)();
    var _j = __read((0, hooks_1.useSubmitter)('users', authState.uid), 1), userSubmit = _j[0];
    var setUpTotpAuth = function () { return __awaiter(void 0, void 0, void 0, function () {
        var auth, currentUser, mf, multiFactorSession, _a, e_1;
        var _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    auth = (0, auth_1.getAuth)(firebase.app);
                    currentUser = auth.currentUser;
                    if (!currentUser) {
                        return [2 /*return*/];
                    }
                    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                    // @ts-ignore
                    currentUser.reloadListener = null;
                    mf = (0, auth_1.multiFactor)(currentUser);
                    return [4 /*yield*/, mf.getSession()];
                case 1:
                    multiFactorSession = _d.sent();
                    _d.label = 2;
                case 2:
                    _d.trys.push([2, 4, , 5]);
                    _a = setTotpSecret;
                    return [4 /*yield*/, auth_1.TotpMultiFactorGenerator.generateSecret(multiFactorSession)];
                case 3:
                    _a.apply(void 0, [_d.sent()]);
                    setError('');
                    return [3 /*break*/, 5];
                case 4:
                    e_1 = _d.sent();
                    if ((_c = (_b = e_1.customData) === null || _b === void 0 ? void 0 : _b.message) === null || _c === void 0 ? void 0 : _c.match(/auth\/requires-recent-login/)) {
                        setNeedsSubmitReauth(true);
                    }
                    else { // 'auth/unverified-email'
                        setError(e_1.message);
                    }
                    return [3 /*break*/, 5];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var recheckEmailVerified = function () { return __awaiter(void 0, void 0, void 0, function () {
        var auth;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    auth = (0, auth_1.getAuth)(firebase.app);
                    if ((_a = auth.currentUser) === null || _a === void 0 ? void 0 : _a.emailVerified) {
                        setEmailVerified(true);
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, ((_b = auth.currentUser) === null || _b === void 0 ? void 0 : _b.reload())];
                case 1:
                    _c.sent();
                    setTimeout(recheckEmailVerified, 2000);
                    return [2 /*return*/];
            }
        });
    }); };
    (0, react_1.useEffect)(function () {
        if (!emailVerified) {
            recheckEmailVerified();
            return;
        }
        setUpTotpAuth();
    }, [emailVerified]);
    var validateTotp = function () { return __awaiter(void 0, void 0, void 0, function () {
        var currentUser, multiFactorAssertion, e_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    currentUser = (0, auth_1.getAuth)(firebase.app).currentUser;
                    if (!totpSecret || !currentUser) {
                        return [2 /*return*/];
                    }
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 4, , 5]);
                    multiFactorAssertion = auth_1.TotpMultiFactorGenerator.assertionForEnrollment(totpSecret, totp);
                    return [4 /*yield*/, (0, auth_1.multiFactor)(currentUser).enroll(multiFactorAssertion, MFA_DISPLAY_NAME)];
                case 2:
                    _a.sent();
                    return [4 /*yield*/, userSubmit({ mfaAddedOn: { totp: firestore_1.Timestamp.now() } })];
                case 3:
                    _a.sent();
                    onClose === null || onClose === void 0 ? void 0 : onClose();
                    return [3 /*break*/, 5];
                case 4:
                    e_2 = _a.sent();
                    setTotpValidationError('Invalid TOTP');
                    return [3 /*break*/, 5];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    if (needsSubmitReauth) {
        return (0, jsx_runtime_1.jsx)(Relogin_1.default, { setNeedsSubmitReauth: setNeedsSubmitReauth, onRelogIn: setUpTotpAuth });
    }
    if (!emailVerified) {
        var handleClose = function () { return onClose === null || onClose === void 0 ? void 0 : onClose(); };
        return (0, jsx_runtime_1.jsx)(VerifyEmail_1.default, { handleClose: handleClose });
    }
    if (!totpSecret) {
        return (0, jsx_runtime_1.jsxs)(material_1.Box, __assign({ mx: "auto", py: 2 }, { children: [error, (0, jsx_runtime_1.jsx)(LoadingSpinner_1.default, {})] }));
    }
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)(material_1.Stack, __assign({ spacing: 2 }, { children: [(0, jsx_runtime_1.jsx)(Heading_1.default, __assign({ level: 3 }, { children: "Setting Up MFA" })), error, (0, jsx_runtime_1.jsx)(Text_1.default, __assign({ level: 1, color: "riverstone" }, { children: "Scan the QR Code below using an authenticator app such as Google Authenticator, Authy, 1Password, LastPass, etc." })), (0, jsx_runtime_1.jsx)(material_1.Box, __assign({ mx: "auto" }, { children: (0, jsx_runtime_1.jsx)(qrcode_react_1.QRCodeSVG, { value: totpSecret.generateQrCodeUrl((_b = authState.email) !== null && _b !== void 0 ? _b : '', MFA_DISPLAY_NAME), size: 380 }) }))] })), (0, jsx_runtime_1.jsx)(material_1.Box, __assign({ pt: 5, pb: 3 }, { children: (0, jsx_runtime_1.jsx)(QRInput_1.default, { onChange: function (e) {
                        if (totpValidationError)
                            setTotpValidationError('');
                        setTotp(e.target.value.replace(/\D/g, '').slice(0, 6));
                    }, onKeyDown: function (e) { return e.key === 'Enter' && validateTotp(); }, value: totp, placeholder: "Input code here", error: !!totpValidationError, helperText: totpValidationError }) })), (0, jsx_runtime_1.jsx)(BlendButton_1.default, __assign({ onClick: validateTotp, fullWidth: true, size: "large" }, { children: "Submit" }))] }));
};
exports.MfaModalContent = MfaModalContent;
exports.default = exports.MfaModalContent;
